'use client'

import { type ILaw } from '@/lib/ris-types'
import { createContext, useContext, type ReactNode } from 'react'

export const NormContext = createContext<ILaw | null>(null)

/**
 * Makes all norm metadata (`normId`, `title`, etc.) accessible though React context
 */
export default function NormProvider ({ children, norm }: { children: ReactNode, norm: ILaw }) {
  return (
    <NormContext.Provider value={norm}>
      {children}
    </NormContext.Provider>
  )
}

export function useNormContext () {
  return useContext(NormContext) as ILaw
}
